import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';

const addAttachmentsNote = async ({ id, files }) => {
  return await Promise.allSettled(
    files.map((file) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('Name', file.name);
      formData.append('FileName', file.name);
      formData.append('ContentType', file.type);
      formData.append('Length', file.size.toString());

      return request.post(
        `/Access/transport/note/${id}/attachments`,
        formData,
        'При добавлении вложения произошла ошибка',
        'Error'
      );
    })
  );
};

const useAddAttachmentsNote = () =>
  useMutation(addAttachmentsNote, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

export default useAddAttachmentsNote;
